import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

import classes from './Filters.module.scss';

import UseModal from 'hooks/use-modal';

import Modal from '@core/components/Modal/Modal';
import FilterIcon from 'assets/icons/filter-icon.svg';

import SearchPageCategories from 'components/common/search/searchpagecategories/SearchPageCategories';
import useWindowSize from 'hooks/use-windowSize';
import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';

const Filters = () => {
	const router = useRouter();
	const [searchParams, setSearchParams] = useState({});
	const [categories, setCategories] = useState('');

	useEffect(() => {
		if (router.isReady) {
			const { id, ...searchparams } = router.query;
			setSearchParams(searchparams);
			setCategories(router?.query?.categories || '');
		}
	}, [router.asPath]);

	const { desktopDevice } = useWindowSize();
	const { pathname } = router;

	const {
		showModal: showCategoryModal,
		destroyModal: destroyCategoryModal,
		show: showCategory
	} = UseModal();

	const searchParamSetter = (key, value) => {
		if (searchParams[key] !== value) {
			if (value === '' || value === undefined) {
				const newSearchParams = { ...searchParams };
				delete newSearchParams[key];

				setSearchParams(newSearchParams);
				router.replace(
					{
						pathname: router.pathname,
						query: { ...newSearchParams }
					},
					undefined,
					{ shallow: true }
				);
			} else {
				setSearchParams((previousState) => ({ ...previousState, [key]: value }));
				router.replace(
					{
						pathname: router.pathname,
						query: { ...searchParams, [key]: value }
					},
					undefined,
					{ shallow: true }
				);
			}
			// value === '' || value === undefined ? searchParams.delete(key) : searchParams.set(key, value);
			// setSearchParams(searchParams, { replace: true });
		}
	};

	const ApplyModalParams = (param, value, closeHanlder) => {
		searchParamSetter(param, value);
		closeHanlder();
	};

	const categoryHandler = (newValue) => {
		if (/category/.test(pathname) && desktopDevice) {
			router.push(`/category/${newValue}`);
		} else {
			let newCategories = categories
				.split(',')
				.filter((id) => id)
				.map((id) => Number(id));
			if (!newCategories.includes(newValue)) {
				newCategories.push(newValue);
			} else {
				newCategories = newCategories.filter((id) => id !== newValue);
			}
			if (!showCategory) {
				searchParamSetter('categories', newCategories.join(','));
			}
			setCategories(newCategories.join(','));
		}
	};

	return (
		<>
			{!desktopDevice ? (
				<>
					<Modal
						title="Filters"
						actions={
							<button
								className={`${classes['apply-modal']}`}
								onClick={() => ApplyModalParams('categories', categories, destroyCategoryModal)}>
								Apply Filters
							</button>
						}
						closeHandler={destroyCategoryModal}
						show={showCategory}
						type={MOBILE_SLIDE_UP}>
						<div className={`${classes['category-wrapper']}`}>
							<SearchPageCategories categoryHandler={categoryHandler} categories={categories} />
						</div>
					</Modal>
					<button onClick={() => showCategoryModal()}>
						<FilterIcon /> Filters
					</button>
				</>
			) : (
				<SearchPageCategories categoryHandler={categoryHandler} categories={categories} />
			)}
		</>
	);
};

export default Filters;
